export default cookiesBar

/** @ngInject */
function cookiesBar($rootScope, CookiesService) {
    return ({
        restrict: 'E',
        template: require('./view.jade')(),
        scope: true,
        link(scope) {
            scope.cookiesAccepted = CookiesService.checkCookiesAcceptance()
            scope.acceptCookies = () => CookiesService.acceptCookies()
            $rootScope.$on('cookiesAccepted', () => {
                scope.cookiesAccepted = true
            })
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/cookies-bar/directive.js